import { format } from "date-fns";
import { csvBlob, saveBlob } from "~/utils/download";
import { roleOptionLabel, userStatus } from "../labels";

// "Exportar matriz" = CSV gerado no FE com o que está carregado (spec §8.5).
export const matrixCsvRows = (users, companies) => [
  ["Nome", "E-mail", "Papel Antecipe", "Status", "Externo", ...companies.map((c) => c.name)],
  ...users.map((user) => [
    user.name || "",
    user.email,
    roleOptionLabel(user.role),
    userStatus(user).label,
    user.isExternal ? "Sim" : "Não",
    ...companies.map((c) => (user.companyIds.includes(c.id) ? "Gestor" : "")),
  ]),
];

export const downloadMatrixCsv = (users, companies, now = new Date()) =>
  saveBlob(csvBlob(matrixCsvRows(users, companies)), `acessos-${format(now, "yyyy-MM-dd")}.csv`);
